/**
 * input.typeが使用中のブラウザで有効か判定する
 */
export const checkInputTypeSupport = (type: string): boolean => {
  const obj = document.createElement('input')
  obj.setAttribute('type', type)
  return obj.type !== 'text'
}

/**
 * closest
 * @param {*} node
 * @param {*} selector
 */
function useOriginalClosest (node: HTMLElement, selector: string): HTMLElement | null {
  return node.closest(selector)
}

function useCustomClosest (node: HTMLElement, selector: string): HTMLElement | null {
  do {
    if ((node.matches || node.msMatchesSelector).call(node, selector)) {
      return node
    }
    // マッチしなかったら親要素を代入
    node = (node.parentElement || node.parentNode) as HTMLElement
  } while (node !== null && node.nodeType === 1)
  return null
}
export const closest = document.body.closest ? useOriginalClosest : useCustomClosest

/**
 * jQuery offset の代わり
 * @param {*} node
 */
export const offset = (node: HTMLElement): { top: number; left: number } | null => {
  if (!node) {
    return null
  }
  const rect = node.getBoundingClientRect()
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
  return {
    top: rect.top + scrollTop,
    left: rect.left + scrollLeft
  }
}
